/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNeighborhoodsTabContent} from '../api'

 export const useQueryGetNeighborhoodsTabContent = createReactQueryHook('getNeighborhoodsTabContent', getNeighborhoodsTabContent)
